import "./App.css";
import "./styles/global.css";
import "./styles/theme-dark.css";
import "./styles/theme.css";

function App() {
  return <div></div>;
}

export default App;
